<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>العملاء</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          fullscreen
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة عميل</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود العميل"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        v-model="select_title"
                        :items="titles"
                        item-text="name"
                        item-value="id"
                        label="أختر اللقب"
                        persistent-hint
                        return-object
                        single-line
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم العميل"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.phone"
                        label="تليفون العميل"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.email"
                        label="الايميل "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.had_eetmani"
                        label="حد ائتماني "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.rasid_efttahi"
                        label="رصيد افتتاحي "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.address"
                        label="العنوان بالتفصيل  "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.mobile"
                        label=" موبايل "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.fax"
                        label=" الفاكس "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.owner"
                        label=" صاحب المنشأة "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.client_manger"
                        label=" المدير المسئول "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.client_level"
                        label="درجة العميل  "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_pay_method"
                        :items="pay_operations"
                        item-text="name"
                        item-value="id"
                        label="  نوع التعامل"
                        persistent-hint
                        return-object
                        single-line
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.drayb_card_number"
                        label="رقم البطاقة الضريبية  "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.commercial_card_number"
                        label="رقم السجل التجاري  "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.clientbarcode"
                        label=" باركود "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_branch"
                        :items="branchs"
                        item-text="name"
                        item-value="id"
                        label="أختر الفرع"
                        persistent-hint
                        return-object
                        single-line
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_mohafza"
                        :items="mohafzas"
                        item-text="name"
                        item-value="id"
                        label="أختر المحافظة"
                        persistent-hint
                        return-object
                        single-line
                        @change="getCities(select_mohafza.id)"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_city"
                        :items="cities"
                        item-text="name"
                        item-value="id"
                        label="أختر المدينة"
                        persistent-hint
                        return-object
                        single-line
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_region"
                        :items="regions"
                        item-text="name"
                        item-value="id"
                        label="أختر المنطقة"
                        persistent-hint
                        return-object
                        single-line
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_mandob_taworid"
                        :hint="
                          `${select_mandob_taworid.job_name}, ${
                            select_mandob_taworid.name
                          }`
                        "
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر مندوب التوريد"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_mandob_sales"
                        :hint="
                          `${select_mandob_sales.job_name}, ${
                            select_mandob_sales.name
                          }`
                        "
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر مندوب المبيعات"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          fullscreen
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل عميل</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md2>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود العميل"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      v-model="select_title_edit"
                      :items="titles"
                      item-text="name"
                      item-value="id"
                      label="أختر اللقب"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم العميل"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="تليفون العميل"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.email"
                      label="الايميل "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.had_eetmani"
                      label="حد ائتماني "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.rasid_efttahi"
                      label="رصيد افتتاحي "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.address"
                      label="العنوان بالتفصيل  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.mobile"
                      label="موبايل  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.fax"
                      label="الفاكس  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.owner"
                      label="صاحب المنشأة  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.client_manger"
                      label="المدير المسئول  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.client_level"
                      label="درجة العميل  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_pay_method_edit"
                      :items="pay_operations"
                      item-text="name"
                      item-value="id"
                      label="  نوع التعامل"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.drayb_card_number"
                      label="رقم البطاقة الضريبية  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.commercial_card_number"
                      label="رقم البطاقة التجارية  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.clientbarcode"
                      label="الباركود  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      v-model="select_branch_edit"
                      :items="branchs"
                      item-text="name"
                      item-value="id"
                      label="أختر الفرع"
                      persistent-hint
                      return-object
                      single-line
                    >
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                        </v-slide-x-reverse-transition>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      v-model="select_mohafza_edit"
                      :items="mohafzas"
                      item-text="name"
                      item-value="id"
                      label="أختر المحافظة"
                      persistent-hint
                      return-object
                      single-line
                      @change="getCities(select_mohafza_edit.id)"
                    >
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                        </v-slide-x-reverse-transition>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      v-model="select_city_edit"
                      :items="cities"
                      item-text="name"
                      item-value="id"
                      label="أختر المدينة"
                      persistent-hint
                      return-object
                      single-line
                    >
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                        </v-slide-x-reverse-transition>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      v-model="select_region_edit"
                      :items="regions"
                      item-text="name"
                      item-value="id"
                      label="أختر المنطقة"
                      persistent-hint
                      return-object
                      single-line
                    >
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                        </v-slide-x-reverse-transition>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_mandob_taworid_edit"
                      :hint="
                        `${select_mandob_taworid_edit.job_name}, ${
                          select_mandob_taworid_edit.name
                        }`
                      "
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر مندوب التوريد"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_mandob_sales_edit"
                      :hint="
                        `${select_mandob_sales_edit.job_name}, ${
                          select_mandob_sales_edit.name
                        }`
                      "
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر مندوب المبيعات"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-btn color="blue" @click="upload_dialog = true"
                      >رفع الملف للعميل</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="clients"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.mobile }}</td>
          <td class="text-xs-right">{{ props.item.had_eetmani }}</td>
          <td class="text-xs-right">{{ props.item.rasid_efttahi }}</td>
          <td class="text-xs-right">
            {{ props.item.branch ? props.item.branch.name : "اختر الفرع" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.client_type ? props.item.client_type.name : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.mandob_sales ? props.item.mandob_sales.name : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.mohafza ? props.item.mohafza.name : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.region ? props.item.region.name : "" }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
          <td class="text-xs-right">
            <a
              v-if="props.item.file != null && props.item.file != ''"
              :href="appUrl + 'files/' + props.item.file"
              target="_blank"
              rel="noopener noreferrer"
              >تحميل</a
            >
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog v-model="upload_dialog" max-width="500px" dir="rtl" align="right">
      <v-card>
        <v-card-title>
          <span class="headline">اضافة ملف للعميل</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <label for="files" class="btn">اختر الملف </label>
                  <input id="files" @change="change_file($event)" type="file" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
          <v-btn color="blue darken-1" flat @click.native="upload"
            >رفع الملف</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  add_client,
  update_client,
  delete_client,
  cities,
  clients_page,
  upload_client_file,
  log_me
} from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    upload_dialog: false,
    headers: [
      {
        text: "الكود",
        align: "right",
        value: "code"
      },
      {
        text: "أسم العميل",
        align: "right",
        value: "name"
      },
      { text: "الموبايل", value: "mobile", align: "right" },
      { text: "حد ائتماني", value: "had_eetmani", align: "right" },
      { text: "رصيد افتتاحي", value: "rasid_efttahi", align: "right" },
      { text: "الفرع", value: "branch.name", align: "right" },
      { text: "نوع العميل", value: "client_type.name", align: "right" },
      { text: "مندوب المبيعات", value: "mandob_sales.name", align: "right" },
      { text: "المحافظة", value: "mohafza.name", align: "right" },
      { text: "المنطقة", value: "region.name", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" },
      { text: "تحميل", value: "control", sortable: false, align: "center" }
    ],
    select_branch: { id: "" },
    select_mandob_taworid: { id: "" },
    select_mandob_sales: { id: "" },
    select_mohafza: { id: "" },
    select_region: { id: "" },
    select_city: { id: "" },
    select_title: { id: "" },
    select_pay_method: { id: "", name: "" },
    select_branch_edit: { id: "" },
    select_mandob_taworid_edit: { id: "" },
    select_mandob_sales_edit: { id: "" },
    select_title_edit: { id: "" },
    select_pay_method_edit: { id: "", name: "" },
    select_mohafza_edit: { id: "" },
    select_region_edit: { id: "" },
    select_city_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    pay_operations: [
      { id: 1, name: "نقدي" },
      { id: 2, name: "أجل" },
      { id: 3, name: "شيكات" }
    ],
    clients: [],
    branchs: [],
    employers: [],
    mohafzas: [],
    regions: [],
    cities: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      phone: "",
      email: "",
      had_eetmani: "",
      rasid_efttahi: "",
      branch_id: "",
      mandob_taworid_id: "",
      mandob_sales_id: "",
      address: "",
      mobile: "",
      fax: "",
      owner: "",
      client_manger: "",
      client_level: "",
      pay_method: "",
      drayb_card_number: "",
      commercial_card_number: "",
      clientbarcode: "",
      client_type_id: "",
      mohafza_id: "",
      region_id: "",
      city_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      phone: "",
      email: "",
      had_eetmani: "",
      rasid_efttahi: "",
      branch_id: "",
      mandob_taworid_id: "",
      mandob_sales_id: "",
      address: "",
      mobile: "",
      fax: "",
      owner: "",
      client_manger: "",
      client_level: "",
      pay_method: "",
      drayb_card_number: "",
      commercial_card_number: "",
      clientbarcode: "",
      client_type_id: "",
      mohafza_id: "",
      region_id: "",
      city_id: ""
    },
    titles: [],
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      emp_id: ""
    },
    file_image: ""
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.clients.length > 0) {
        return (this.code =
          parseInt(this.clients[this.clients.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
    this.appUrl = appUrl;

    clients_page().then(response => {
      this.clients = response.data.clients;
      this.branchs = response.data.branches;
      this.employers = response.data.employers;
      this.titles = response.data.client_types;
      this.mohafzas = response.data.mohafzas;
      this.regions = response.data.regions;
      this.pagination.totalItems = response.data.clients.length;
      this.loading = false;
    });
  },

  methods: {
    initialize() {},
    getCities(id) {
      cities(id).then(response => {
        this.cities = response.data;
      });
    },

    change_file(event) {
      this.file_image = event.target.files[0];
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.phone = item.phone;
      this.editedItem.email = item.email;
      this.editedItem.had_eetmani = item.had_eetmani;
      this.editedItem.rasid_efttahi = item.rasid_efttahi;
      this.editedItem.address = item.address;
      this.editedItem.mobile = item.mobile;
      this.editedItem.fax = item.fax;
      this.editedItem.owner = item.owner;
      this.editedItem.client_manger = item.client_manger;
      this.editedItem.client_level = item.client_level;
      this.editedItem.drayb_card_number = item.drayb_card_number;
      this.editedItem.commercial_card_number = item.commercial_card_number;
      this.editedItem.clientbarcode = item.clientbarcode;
      this.editedItem.client_type_id = item.client_type_id;
      this.editedItem.client_type = item.client_type;
      this.select_pay_method_edit = {
        id: item.pay_method_id,
        name: item.pay_method
      };
      this.select_branch_edit = item.branch;
      item.mandob_taworid
        ? (this.select_mandob_taworid_edit = item.mandob_taworid)
        : "";
      item.mandob_sales
        ? (this.select_mandob_sales_edit = item.mandob_sales)
        : "";
      item.mohafza ? (this.select_mohafza_edit = item.mohafza) : "";
      item.mohafza ? this.getCities(item.mohafza.id) : "";
      item.region ? (this.select_region_edit = item.region) : "";
      item.city ? (this.select_city_edit = item.city) : "";

      // this.select_title_edit=item.client_type

      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.clients.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_client(frmData2, item.id).then(response => {
            if (response.data == "yes") {
              let myUser = JSON.parse(localStorage.getItem("user"));
              this.loading = false;
              this.clients.splice(index, 1);
              this.close();
              var frmData3 = new FormData();
              frmData3.append("title", "حذف عميل ");
              frmData3.append(
                "body",
                "تم حذف عميل بإسم " +
                  item.name +
                  " وكود " +
                  item.code +
                  " بواسطة " +
                  myUser.name
              );
              frmData3.append("type", "delete_client");
              frmData3.append("user_id", myUser.id);
              log_me(frmData3).then(response => {
                if (response.data == true) {
                  let mytitle = "حذف عميل ";
                  let mybody =
                    "تم حذف عميل بإسم " +
                    item.name +
                    " وكود " +
                    item.code +
                    " بواسطة " +
                    myUser.name;
                  this.$toastr.warning(mybody, mytitle, {
                    closeButton: true,
                    progressBar: true,
                    positionClass: "toast-bottom-left",
                    preventDuplicates: false,
                    timeOut: "25000"
                  });
                }
              });
              this.$swal("success", "تم حذف العميل بنجاح ", "success");
            } else {
              this.loading = false;
              this.$swal(
                "error",
                "لا يمكن  حذف العميل لأنه يملك  فواتير ومرتجعات  ",
                "error"
              );
            }
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      this.upload_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },
    upload() {
      if (this.file_image != "") {
        var frmData = new FormData();
        frmData.append("file", this.file_image);
        frmData.append("id", this.editedItem.id);
        upload_client_file(frmData).then(res => {
          this.close();
          this.$swal("Success", "تم رفع الملف بنجاح ", "success");

          setInterval(() => {
            this.$router.go(0);
          }, 1000);
        });
      }
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_mandob_taworid.id != "" &&
          this.select_mandob_sales.id != "" &&
          this.select_title.id != "" &&
          this.select_pay_method.id != "" &&
          this.select_mohafza.id != "" &&
          this.select_region.id != "" &&
          this.select_city.id != ""
        ) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          this.newItem.mandob_taworid_id = this.select_mandob_taworid.id;
          this.newItem.mandob_sales_id = this.select_mandob_sales.id;
          this.newItem.name = this.select_title.name
            ? this.select_title.name + " " + this.newItem.name
            : this.newItem.name;
          this.newItem.client_type_id = this.select_title.id;
          this.newItem.pay_method = this.select_pay_method.name;
          this.newItem.pay_method_id = this.select_pay_method.id;
          this.newItem.mohafza_id = this.select_mohafza.id;
          this.newItem.region_id = this.select_region.id;
          this.newItem.city_id = this.select_city.id;

          this.madionia.madionia_before = 0;
          this.madionia.cost_or_money = this.newItem.rasid_efttahi;
          this.madionia.madionia_after = this.newItem.rasid_efttahi;
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "efftahi";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.emp_id = myUser.id;
          var frmData = new FormData();
          frmData.append("client", JSON.stringify(this.newItem));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_client(frmData).then(response => {
            this.loading = false;
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.titles, this.$options.data().titles);
            // Object.assign(this.$data.branchs, this.$options.data().branchs);
            // Object.assign(this.$data.employers, this.$options.data().employers);
            this.clients.push(response.data);
            this.close();
            var frmData3 = new FormData();
            frmData3.append("title", "اضافة عميل جديد");
            frmData3.append(
              "body",
              "تم اضافة عميل جديد بإسم " +
                this.newItem.name +
                " وكود " +
                this.newItem.code +
                " فرع " +
                this.select_branch.name +
                " بواسطة " +
                myUser.name
            );
            frmData3.append("type", "new_client");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "اضافة عميل جديد";
                let mybody =
                  "تم اضافة عميل جديد بإسم " +
                  this.newItem.name +
                  " وكود " +
                  this.newItem.code +
                  " فرع " +
                  this.select_branch.name +
                  " بواسطة " +
                  myUser.name;
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_mandob_taworid_edit.id != "" &&
          this.select_mandob_sales_edit.id != "" &&
          // this.select_pay_method_edit.id != "" &&
          this.select_mohafza_edit.id != "" &&
          this.select_region_edit.id != "" &&
          this.select_city_edit.id != ""
        ) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.name = this.select_title_edit.name
            ? this.select_title_edit.name + " " + this.editedItem.name
            : this.editedItem.name;
          this.editedItem.client_type_id = this.select_title_edit.id
            ? this.select_title_edit.id
            : this.editedItem.client_type_id;
          this.editedItem.client_type = this.select_title_edit.name
            ? this.select_title_edit.name
            : this.editedItem.client_type;
          this.editedItem.pay_method = this.select_pay_method_edit.name
            ? this.select_pay_method_edit.name
            : "";
          this.editedItem.pay_method_id = this.select_pay_method_edit.id
            ? this.select_pay_method_edit.id
            : "";
          this.editedItem.branch_id = this.select_branch_edit.id;
          this.editedItem.mohafza_id = this.select_mohafza_edit.id;
          this.editedItem.region_id = this.select_region_edit.id;
          this.editedItem.city_id = this.select_city_edit.id;
          this.editedItem.mandob_taworid_id = this.select_mandob_taworid_edit.id;
          this.editedItem.mandob_sales_id = this.select_mandob_sales_edit.id;
          var frmData = new FormData();
          frmData.append("client", JSON.stringify(this.editedItem));
          update_client(frmData, item_id).then(response => {
            Vue.set(
              this.clients,
              this.clients.findIndex(f => f.id === item_id),
              response.data
            );
            Object.assign(
              this.$data.select_title_edit,
              this.$options.data().select_title_edit
            );
            Object.assign(this.$data.titles, this.$options.data().titles);
            this.loading = false;
            this.close();
            let myUser = JSON.parse(localStorage.getItem("user"));
            var frmData3 = new FormData();
            frmData3.append("title", "تعديل عميل ");
            frmData3.append(
              "body",
              "تم تعديل عميل  بإسم " +
                this.editedItem.name +
                " وكود " +
                this.editedItem.code +
                " فرع " +
                this.select_branch_edit.name +
                " بواسطة " +
                myUser.name
            );
            frmData3.append("type", "update_client");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "تعديل عميل ";
                let mybody =
                  "تم تعديل عميل  بإسم " +
                  this.editedItem.name +
                  " وكود " +
                  this.editedItem.code +
                  " فرع " +
                  this.select_branch_edit.name +
                  " بواسطة " +
                  myUser.name;
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
